export default __webpack_public_path__ + "static/Room-With-A-View-Hollywood-Sign-51c5835cdf7cee66e6d84ca360083e74.jpg";